{
  "familyId": "REK-VOLGORDE",
  "questions": [
    {
      "id": "REK-VOLGORDE-001",
      "familyId": "REK-VOLGORDE",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "volgorde",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Wat is 3 + 4 × 2?",
      "options": ["11", "14", "10", "24"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde van bewerkingen",
            "content": "Onthoud de ezelsbrug: 'Hoe Moeilijk × Dat + Is' — Haakjes → Machten → × en ÷ → + en −. Vermenigvuldigen gaat altijd vóór optellen. Dus: 3 + 4 × 2 → eerst 4 × 2 = 8, dan 3 + 8 = 11.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_keer_voor_plus",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.links-naar-rechts", "label": "Rekent van links naar rechts zonder voorrangsregels", "optionIndex": 1 },
          { "id": "rek.bewerking-verward", "label": "Koppelt verkeerde getallen aan de bewerking", "optionIndex": 2 },
          { "id": "rek.bewerking-verward", "label": "Vermenigvuldigt alle getallen in de som", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Vermenigvuldigen gaat vóór optellen. Eerst 4 × 2 = 8. Dan 3 + 8 = 11. De rekenregel is: Haakjes → Machten → × en ÷ → + en −. Controleer: 3 + 8 = 11 ✓",
        "solutionSteps": ["Eerst × : 4 × 2 = 8", "Dan + : 3 + 8 = 11"],
        "distractorExplanations": {
          "0": "Goed! Eerst vermenigvuldigen: 4 × 2 = 8. Dan optellen: 3 + 8 = 11.",
          "1": "Je dacht waarschijnlijk dat je van links naar rechts rekent: 3 + 4 = 7, dan 7 × 2 = 14. Maar vermenigvuldigen heeft voorrang op optellen. Onthoud: × en ÷ gaan altijd vóór + en −.",
          "2": "Je dacht waarschijnlijk dat je 3 × 2 moet rekenen in plaats van 4 × 2. Maar de × staat tussen 4 en 2, niet tussen 3 en 2. Onthoud: kijk goed welke getallen bij de vermenigvuldiging horen.",
          "3": "Je dacht waarschijnlijk dat je alles moet vermenigvuldigen: 3 × 4 × 2 = 24. Maar de + is een optelling, geen vermenigvuldiging. Onthoud: lees de tekens goed — + en × zijn verschillende bewerkingen."
        }
      }
    },
    {
      "id": "REK-VOLGORDE-002",
      "familyId": "REK-VOLGORDE",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "volgorde",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "fill_in",
      "question": "Wat is (5 + 3) × 4?",
      "options": [],
      "correctAnswer": "32",
      "data": {
        "acceptedAnswers": ["32"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Haakjes gaan altijd eerst",
            "content": "Alles wat tussen haakjes staat, bereken je als eerste. (5 + 3) = 8. Daarna: 8 × 4 = 32. Haakjes hebben de hoogste prioriteit.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_haakjes",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.haakjes-genegeerd", "label": "Negeert haakjes en volgt standaard voorrang" },
          { "id": "rek.bewerking-verward", "label": "Interpreteert haakjes verkeerd (als vermenigvuldiging of als selectie)" }
        ]
      },
      "feedback": {
        "explanationText": "Haakjes gaan altijd eerst: (5 + 3) = 8. Daarna vermenigvuldig je: 8 × 4 = 32. Haakjes hebben de hoogste prioriteit in de rekenregels.",
        "solutionSteps": ["Haakjes: 5 + 3 = 8", "Vermenigvuldigen: 8 × 4 = 32"]
      }
    },
    {
      "id": "REK-VOLGORDE-003",
      "familyId": "REK-VOLGORDE",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "volgorde",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Wat is 20 − 12 ÷ 4?",
      "options": ["2", "17", "8", "23"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen gaat vóór aftrekken",
            "content": "Volgorde: × en ÷ gaan vóór + en −. Dus: eerst 12 ÷ 4 = 3. Dan: 20 − 3 = 17. Niet van links naar rechts!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_delen_voor_aftrekken",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.links-naar-rechts", "label": "Rekent van links naar rechts zonder voorrangsregels", "optionIndex": 0 },
          { "id": "rek.voorrangsregels-fout", "label": "Trekt eerst af en deelt daarna", "optionIndex": 2 },
          { "id": "rek.bewerking-verward", "label": "Verwart min-teken met plus-teken", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Delen gaat vóór aftrekken. Eerst 12 ÷ 4 = 3. Dan 20 − 3 = 17. De rekenregel is: × en ÷ hebben voorrang op + en −. Controleer: 20 − 3 = 17 ✓",
        "solutionSteps": ["Eerst ÷ : 12 ÷ 4 = 3", "Dan − : 20 − 3 = 17"],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je van links naar rechts rekent: 20 − 12 = 8, dan 8 ÷ 4 = 2. Maar delen heeft voorrang op aftrekken. Onthoud: ÷ gaat altijd vóór −, ongeacht de positie in de som.",
          "1": "Goed! Eerst delen: 12 ÷ 4 = 3. Dan aftrekken: 20 − 3 = 17.",
          "2": "Je dacht waarschijnlijk dat je eerst aftrekt: 20 − 12 = 8. Maar je moet eerst delen: 12 ÷ 4 = 3. Dan pas aftrekken: 20 − 3 = 17. Onthoud: zoek altijd eerst de × of ÷ in de som.",
          "3": "Je dacht waarschijnlijk dat je optelt in plaats van aftrekt: 20 + 3 = 23. Maar het teken is − (min), niet + (plus). Onthoud: lees het rekenteken goed — 20 − 3 = 17."
        }
      }
    },
    {
      "id": "REK-VOLGORDE-004",
      "familyId": "REK-VOLGORDE",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "volgorde",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Wat is 2 × (10 − 3) + 5?",
      "options": ["24", "14", "9", "19"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap: haakjes → × → +",
            "content": "Stap 1: Haakjes eerst: (10 − 3) = 7. Stap 2: Vermenigvuldigen: 2 × 7 = 14. Stap 3: Optellen: 14 + 5 = 19. De 5 staat buiten de haakjes, dus die tel je als laatste op.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_haakjes_combinatie",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.haakjes-genegeerd", "label": "Denkt dat +5 ook binnen de haakjes valt", "optionIndex": 0 },
          { "id": "rek.onvolledige-berekening", "label": "Stopt na de vermenigvuldiging zonder de optelling af te maken", "optionIndex": 1 },
          { "id": "rek.voorrangsregels-fout", "label": "Past de volgorderegels verkeerd toe", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Werk stap voor stap. Eerst de haakjes: (10 − 3) = 7. Dan vermenigvuldigen: 2 × 7 = 14. Als laatste optellen: 14 + 5 = 19. De + 5 staat buiten de haakjes en komt pas aan het eind.",
        "solutionSteps": ["Haakjes: 10 − 3 = 7", "Vermenigvuldigen: 2 × 7 = 14", "Optellen: 14 + 5 = 19"],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de 5 ook binnen de haakjes hoort: 2 × (10 − 3 + 5) = 2 × 12 = 24. Maar de + 5 staat buiten de haakjes. Onthoud: kijk goed waar de haakjes sluiten — alleen wat ertussen staat reken je eerst uit.",
          "1": "Je dacht waarschijnlijk dat je klaar bent na het vermenigvuldigen: 2 × 7 = 14. Maar er staat nog + 5 achter. Onthoud: werk de hele som af — 14 + 5 = 19.",
          "2": "Je dacht waarschijnlijk dat de volgorde anders is. Controleer stap voor stap: haakjes → × → + geeft (10 − 3) = 7, dan 2 × 7 = 14, dan 14 + 5 = 19. Onthoud: volg altijd de vaste volgorde.",
          "3": "Goed! (10 − 3) = 7, dan 2 × 7 = 14, dan 14 + 5 = 19."
        }
      }
    },
    {
      "id": "REK-VOLGORDE-005",
      "familyId": "REK-VOLGORDE",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "volgorde",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Welke bewerking doe je EERST bij: 8 + 6 × 3 − 2?",
      "options": ["6 × 3", "8 + 6", "3 − 2", "8 + 6 × 3"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zoek de × of ÷ zonder haakjes",
            "content": "Er zijn geen haakjes. Zoek dan de × of ÷: dat is 6 × 3. Die doe je als eerste. Daarna van links naar rechts: 8 + 18 − 2 = 24.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_herkennen",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.links-naar-rechts", "label": "Begint van links naar rechts met optellen", "optionIndex": 1 },
          { "id": "rek.links-naar-rechts", "label": "Begint van rechts met aftrekken", "optionIndex": 2 },
          { "id": "rek.voorrangsregels-fout", "label": "Doet meerdere bewerkingen tegelijk", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Er zijn geen haakjes, dus zoek de vermenigvuldiging of deling. Dat is 6 × 3 — die doe je eerst. 6 × 3 = 18. Daarna van links naar rechts: 8 + 18 − 2 = 24.",
        "solutionSteps": ["Geen haakjes → zoek × of ÷", "Gevonden: 6 × 3 → doe dit eerst", "Dan van links naar rechts: 8 + 18 − 2 = 24"],
        "distractorExplanations": {
          "0": "Goed! Vermenigvuldigen gaat vóór optellen en aftrekken. 6 × 3 = 18 doe je eerst.",
          "1": "Je dacht waarschijnlijk dat je van links naar rechts begint: 8 + 6 = 14. Maar vermenigvuldigen heeft voorrang op optellen. Onthoud: zoek altijd eerst de × of ÷ in de som, ongeacht de positie.",
          "2": "Je dacht waarschijnlijk dat je van rechts naar links begint: 3 − 2 = 1. Maar vermenigvuldigen heeft voorrang op aftrekken. Onthoud: × en ÷ gaan altijd vóór + en −.",
          "3": "Je dacht waarschijnlijk dat je meerdere bewerkingen tegelijk doet. Maar je doet eerst alleen 6 × 3 = 18. Daarna reken je verder: 8 + 18 − 2 = 24. Onthoud: werk stap voor stap, één bewerking tegelijk."
        }
      }
    },
    {
      "id": "REK-VOLGORDE-006",
      "familyId": "REK-VOLGORDE",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "volgorde",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "ordering",
      "question": "Zet de rekenstappen in de juiste volgorde voor: 2 + 3 × 4 − 1",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["2 + 12 − 1", "3 × 4 = 12", "14 − 1 = 13", "Antwoord: 13"],
        "correctOrder": [1, 0, 2, 3]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde van bewerkingen",
            "content": "Stap 1: Vermenigvuldigen gaat eerst → 3 × 4 = 12. Stap 2: Vul in → 2 + 12 − 1. Stap 3: Van links naar rechts → 14 − 1 = 13.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_stappen_ordenen",
      "variantIndex": 6,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Eerst vermenigvuldigen: 3 × 4 = 12. Dan invullen: 2 + 12 − 1. Dan van links naar rechts: 2 + 12 = 14, dan 14 − 1 = 13.",
        "solutionSteps": ["Stap 1: 3 × 4 = 12 (× gaat eerst)", "Stap 2: 2 + 12 − 1 (invullen)", "Stap 3: 14 − 1 = 13 (van links naar rechts)", "Antwoord: 13"]
      }
    },
    {
      "id": "REK-VOLGORDE-007",
      "familyId": "REK-VOLGORDE",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "volgorde",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "ordering",
      "question": "Zet de rekenstappen in de juiste volgorde voor: (8 − 3) × 2 + 6",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["5 × 2 + 6", "10 + 6 = 16", "(8 − 3) = 5", "Antwoord: 16"],
        "correctOrder": [2, 0, 1, 3]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Haakjes → × → +",
            "content": "Stap 1: Haakjes eerst → (8 − 3) = 5. Stap 2: Vermenigvuldigen → 5 × 2 = 10. Stap 3: Optellen → 10 + 6 = 16.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_haakjes_stappen",
      "variantIndex": 7,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Eerst haakjes: (8 − 3) = 5. Dan vermenigvuldigen: 5 × 2 = 10. Dan optellen: 10 + 6 = 16. Controleer: (8−3)=5, 5×2=10, 10+6=16 ✓",
        "solutionSteps": ["Stap 1: (8 − 3) = 5 (haakjes eerst)", "Stap 2: 5 × 2 + 6 (invullen)", "Stap 3: 10 + 6 = 16 (× vóór +)", "Antwoord: 16"]
      }
    },
    {
      "id": "REK-VOLGORDE-008",
      "familyId": "REK-VOLGORDE",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "volgorde",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "ordering",
      "question": "Zet deze bewerkingen in de juiste volgorde van prioriteit (hoogste eerst).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["+ en −", "Haakjes ( )", "× en ÷", "Machten"],
        "correctOrder": [1, 3, 2, 0]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde van bewerkingen",
            "content": "De vaste volgorde is: 1. Haakjes → 2. Machten → 3. × en ÷ → 4. + en −. Onthoud: 'Hoe Moeilijk × Dat + Is' (H-M-×÷-+−).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_prioriteit_ordenen",
      "variantIndex": 8,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "De vaste volgorde is: 1. Haakjes (hoogste prioriteit) → 2. Machten → 3. Vermenigvuldigen en delen → 4. Optellen en aftrekken (laagste prioriteit). Controleer: Haakjes→Machten→×÷→+− ✓",
        "solutionSteps": ["1. Haakjes ( ) — hoogste prioriteit", "2. Machten — tweede prioriteit", "3. × en ÷ — derde prioriteit", "4. + en − — laagste prioriteit"]
      }
    },
    {
      "id": "REK-VOLGORDE-009",
      "familyId": "REK-VOLGORDE",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "volgorde",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "ordering",
      "question": "Zet de rekenstappen voor 5 + 3² × 2 in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["5 + 9 × 2", "5 + 18", "3² = 9", "= 23"],
        "correctOrder": [2, 0, 1, 3]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde: Machten → × → +",
            "content": "Stap 1: Machten eerst → 3² = 9. Stap 2: Vermenigvuldigen → 9 × 2 = 18. Stap 3: Optellen → 5 + 18 = 23. Onthoud: Haakjes → Machten → × en ÷ → + en −.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_stappen_ordenen_macht",
      "variantIndex": 9,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Eerst machten: 3² = 9. Dan vermenigvuldigen: 5 + 9 × 2 → 5 + 18. Dan optellen: 5 + 18 = 23. Controleer: 5 + 18 = 23 ✓",
        "solutionSteps": [
          "Stap 1: Machten → 3² = 9",
          "Stap 2: Invullen → 5 + 9 × 2",
          "Stap 3: Vermenigvuldigen → 5 + 18",
          "Stap 4: Optellen → = 23"
        ]
      }
    },
    {
      "id": "REK-VOLGORDE-010",
      "familyId": "REK-VOLGORDE",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "volgorde",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "ordering",
      "question": "Zet de rekenstappen voor (12 − 4) ÷ 2 + 3 × 5 in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["4 + 15 = 19", "(12 − 4) = 8", "8 ÷ 2 = 4 en 3 × 5 = 15", "= 19"],
        "correctOrder": [1, 2, 0, 3]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Haakjes → × en ÷ → + en −",
            "content": "Stap 1: Haakjes eerst → (12 − 4) = 8. Stap 2: × en ÷ (van links naar rechts) → 8 ÷ 2 = 4 en 3 × 5 = 15. Stap 3: Optellen → 4 + 15 = 19.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_stappen_ordenen_complex",
      "variantIndex": 10,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Eerst haakjes: (12 − 4) = 8. Dan × en ÷: 8 ÷ 2 = 4 en 3 × 5 = 15. Dan optellen: 4 + 15 = 19. Controleer: 4 + 15 = 19 ✓",
        "solutionSteps": [
          "Stap 1: Haakjes → (12 − 4) = 8",
          "Stap 2: × en ÷ → 8 ÷ 2 = 4 en 3 × 5 = 15",
          "Stap 3: + → 4 + 15 = 19"
        ]
      }
    },
    {
      "id": "REK-VOLGORDE-011",
      "familyId": "REK-VOLGORDE",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "volgorde",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "error_spotting",
      "question": "Yara rekent 3 + 4 × 2 uit. Vind de foute stap in haar berekening en verbeter hem.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "instruction": "Tik op de foute stap en typ de juiste berekening",
        "text": "Yara: eerst 3+4=7 daarna 7×2=14 . Antwoord: 14",
        "errors": [
          {
            "word": "3+4=7",
            "position": 2,
            "correction": "4×2=8",
            "rule": "Vermenigvuldigen gaat vóór optellen (× vóór +). Yara moest eerst 4×2 doen — dan 3+8=11."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De voorrangsregels",
            "content": "1. Haakjes eerst. 2. Dan × en ÷ (van links naar rechts). 3. Dan + en − (van links naar rechts). Bij 3 + 4 × 2: × gaat vóór +, dus eerst 4 × 2 = 8, dan 3 + 8 = 11. Let op: 'van links naar rechts' geldt alleen tussen gelijke bewerkingen (+ en − samen, of × en ÷ samen).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_links_naar_rechts_fout",
      "variantIndex": 11,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.voorrangsregels-fout", "label": "Rekent van links naar rechts, negeert × vóór +" }
        ]
      },
      "feedback": {
        "explanationText": "Yara's fout zit in de allereerste stap: '3+4=7'. Vermenigvuldigen gaat altijd vóór optellen — ze had eerst 4×2=8 moeten doen, dan 3+8=11. De voorrangsregels zijn: 1) haakjes, 2) × en ÷ (van links naar rechts), 3) + en − (van links naar rechts). Controleer: 3 + 4 × 2 = 3 + 8 = 11, niet 14.",
        "solutionSteps": [
          "Lees de som: 3 + 4 × 2",
          "Volgorde-regel: × eerst → 4 × 2 = 8",
          "Dan + → 3 + 8 = 11",
          "Yara's fout: zij rekende 3 + 4 eerst → verkeerde volgorde",
          "Controle: 3 + 8 = 11 (niet 14) ✓"
        ],
        "distractorExplanations": {
          "3+4=7": "Goed gevonden! Yara mocht 3+4 niet als eerste doen. Vermenigvuldigen gaat vóór optellen: eerst 4×2=8, dan 3+8=11."
        }
      }
    }
  ]
}